// extracted by mini-css-extract-plugin
export var container = "HomeAbout-module--container--fd319";
export var core = "HomeAbout-module--core--cf0eb";
export var core2 = "HomeAbout-module--core-2--3d26e";
export var heading = "HomeAbout-module--heading--0c111";
export var heading1 = "HomeAbout-module--heading-1--3a3ae";
export var heading2 = "HomeAbout-module--heading-2--11ae6";
export var image = "HomeAbout-module--image--769d9";
export var imageWrapper = "HomeAbout-module--image-wrapper--94b44";
export var pretitle = "HomeAbout-module--pretitle--d6bbc";